export default {"gitHash":"73665eaffbb9bbf069b57b9a4c6b9b60c44b0708","gitHashShort":"73665ea","time":1644882030036,"platform":"linux","arch":"x64"};